import { Subscription } from "@rails/actioncable"
import consumer from "./consumer"

export function subscribeCallbacksDue(onChange: () => void): Subscription {
  return consumer.subscriptions.create(
    { channel: "CallbacksDueChannel" },
    {
      connected() {
        onChange()
      },
      received() {
        onChange()
      }
    }
  )
}
